import React from 'react'
import { useLottie } from "lottie-react";
import SearchLoader from './searchLoader.json';
import { Content, ContentLotile } from '../../StyledLoader';
const SearchLottie = () => {
    const options = {
        animationData: SearchLoader,
        loop: true
    };

    const { View } = useLottie(options);

    return <Content><ContentLotile >{View}</ContentLotile></Content>;
}

export default SearchLottie